import { request2 } from "/src/utils/index.js";


export function Upload(params) {
  return request2.post("file/upload", params);
}

